import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '../lib/api';
import { CITY_REVIEW_IMAGES, FAKE_REVIEWS } from '../lib/reviews';
import PageMascots from '../components/PageMascots';

export default function Reviews() {
  const [list, setList] = useState(FAKE_REVIEWS);
  const [page, setPage] = useState(1);
  const perPage = 24;

  useEffect(() => {
    api.get('/reviews/public')
      .then(r => setList(r.data?.length ? r.data.map((review, index) => ({
        ...review,
        image: CITY_REVIEW_IMAGES[review.city] || FAKE_REVIEWS[index % FAKE_REVIEWS.length].image,
      })) : FAKE_REVIEWS))
      .catch(() => setList(FAKE_REVIEWS));
  }, []);

  const totalPages = Math.max(1, Math.ceil(list.length / perPage));
  const visibleReviews = list.slice((page - 1) * perPage, page * perPage);

  return (
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 overflow-visible">
      <PageMascots />
      <div className="relative z-10">
      <div className="badge-cozy mb-3">Reviews</div>
      <h1 className="text-4xl sm:text-5xl font-heading font-semibold mb-4">Words from curious travellers</h1>
      <p className="text-[#a3a3a3] max-w-3xl mb-10">
        Early community stories from people who booked a private Ghostie meetup and wanted the city to feel stranger, warmer and more personal.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {visibleReviews.map((r, i) => (
          <motion.div key={r.review_id} className="magical-card overflow-hidden"
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ delay: i * 0.03 }}>
            <img src={r.image || FAKE_REVIEWS[i % FAKE_REVIEWS.length].image} alt={`${r.city || 'City'} atmosphere`} className="h-48 w-full object-cover"/>
            <div className="p-6">
              <div className="text-[#f97316] mb-3 text-lg">{'★'.repeat(r.rating || 5)}</div>
              <p className="text-base mb-4 leading-relaxed">"{r.text || 'A wonderful meetup.'}"</p>
              <div className="text-xs text-[#a3a3a3] font-accent uppercase tracking-widest">{r.first_name || 'Traveller'}</div>
            </div>
          </motion.div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center flex-wrap gap-2 mt-10">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(n => (
            <button key={n} onClick={()=>setPage(n)} className={`chip ${page === n ? 'active' : ''}`}>
              {n}
            </button>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}
